import $ from 'jquery';

$.DataTable = require('datatables.net')

const NavOptions = (function () {
    var selectAll = async function () {
        $(".selected").prop("checked", true);
        return $("[type='checkbox']:checked").length;
    }

    var DeselectAll = async function () {
        $(".selected").prop("checked", false);
        return $("[type='checkbox']:checked").length;
    }

    const toggleSelectAll = async function (e, orders, setSelectedRows) {
        e.target.active = !e.target.active; // Toggle the active state
        const allRows = document.querySelectorAll('tr[class^="order_id_"]');  // Select all table rows with class 'order_id_*'
        
        if (e.target.active) {
            // Select orders whose ids match those in the table rows
            const selectedRows = orders
                .filter(order => Array.from(allRows).some(row => row.classList.contains(`order_id_${order.id}`))) // Filter orders based on table row classes
                .map(order => order.id);  // Extract their ids
            
            setSelectedRows(selectedRows);
        } else {
            setSelectedRows([]); // Deselect all orders if not active
        }
    };
    


    var CountSelected = async function () {
        return selectedCount;
    }

    var initDataTable = function (tid) {
        $(document).ready(function () {
            $('.oldOrders tfoot th').each(function () {
                var title = $('.oldOrders thead th').eq($(this).index()).text();
                $(this).html('<input type="text" placeholder="Search ' + title + '" />');
            });

            var previousUrl = document.referrer;
            var currentUrl = window.location.href;

            // Build a second header row holding a per-column search input.
            // Columns vary by terminal, so we derive the inputs from the header.
            // The row is collapsed by default and toggled via toggleColumnSearch().
            $('.allOrders').each(function () {
                var $table = $(this);
                var $thead = $table.find('thead');
                $thead.find('tr.column-filters').remove();
                var $tr = $('<tr class="column-filters" style="display:none;"></tr>');
                $thead.find('tr').first().find('th').each(function () {
                    var title = $(this).text().trim();
                    // Skip action columns - nothing to search on them.
                    if (title === 'Act.' || title === 'Action' || title === '') {
                        $tr.append('<th></th>');
                    } else {
                        $tr.append(
                            '<th><input type="text" class="column-search" ' +
                            'placeholder="Search ' + title + '" ' +
                            'style="width:100%;font-weight:normal;padding:2px 4px;color:#000;" /></th>'
                        );
                    }
                });
                $thead.append($tr);
            });

            var table = $('.allOrders').DataTable({
                "pageLength": 100,
                "bDestroy": true,
                "stateSave": true,
                fixedHeader: true,
                order: [], // Table order is set in backend get_orders_q()
                orderCellsTop: true, // Sort from the top header row, filters live in the 2nd row
                fixedHeader: true,
                // Saves and loads table state (sorting...) when switching between tabs
                stateSaveCallback: function(settings,data) {
                    localStorage.setItem( 'DataTables_' + tid, JSON.stringify(data) );
                },
                stateLoadCallback: function(settings) {
                return JSON.parse( localStorage.getItem( 'DataTables_' + tid ) )
                }
            }).columns.adjust();

            // Wire each search input to filter its own column.
            table.columns().every(function (index) {
                var column = this;
                var $input = $('.allOrders thead tr.column-filters th').eq(index).find('input');
                // Restore any saved per-column search value (stateSave).
                if (column.search()) {
                    $input.val(column.search());
                }
                $input.on('keyup change', function (e) {
                    // Don't let clicks/keys in the header trigger column sorting.
                    e.stopPropagation();
                    if (column.search() !== this.value) {
                        column.search(this.value).draw();
                    }
                });
                $input.on('click', function (e) {
                    e.stopPropagation();
                });
            });
        });
    }

    // Show/hide the per-column search row.
    var toggleColumnSearch = function () {
        $('.allOrders thead tr.column-filters').toggle();
    }
    return {
        selectAll: selectAll,
        DeselectAll: DeselectAll,
        initDataTable: initDataTable,
        CountSelected: CountSelected,
        toggleSelectAll: toggleSelectAll,
        toggleColumnSearch: toggleColumnSearch,
    }

})();

export default NavOptions;
